// import { get } from "lodash";

export default {
  getCareerListings: (state) => state.careerListings,
};
